import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Validator from 'validatorjs'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'
import { retrieveUser, saveUser } from 'utils/auth'

import { USER_PROFILE_URL, UPDATE_PROFILE_PICTURE_URL } from 'constants'

import Input from 'components/Input'
import Button from 'components/Button'
import InputFile from 'components/InputFile'

import { statusChanged } from 'components/RequestStatus/actions'
import { updateUser } from 'reducers/global/user/actions'

import './index.scss'


export class EditAccount extends BaseComponent {
  static validationRules = {
    first_name: 'string|required|min:2',
    last_name: 'string|required|min:2',
    email: 'required|email',
    confirm_email: 'required|same:email'
  }

  constructor(props) {
    super(props)

    this._bind('_handleChange', '_handleSubmit', '_validate', '_handlePictureClick', '_handlePictureChange', '_updatePicture')

    const user = retrieveUser()
    this.state = {
      buttonProps: {
        disabled: false
      },
      formData: {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        confirm_email: user.email
      },
      errors: {},
      picture: {
        message: 'No se ha seleccionado archivo',
        file: null,
        status: false
      }
    }
  }

  _handleChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e)
  }

  _handlePictureClick(e) {
    e.preventDefault()
    this.inputPicture.click()
  }

  _handlePictureChange(e) {
    e.preventDefault()
    this.setState({
      picture: {
        message: 'Archivo seleccionado',
        file: e.target.files[0],
        status: true
      }
    })
  }

  _handleSubmit(e) {
    e.preventDefault()
    this.props.updateRequestStatus('progress', 'Cambio de datos en progreso...')

    request(USER_PROFILE_URL(retrieveUser().uuid), {
      method: 'PUT',
      body: { ...this.state.formData }
    })
    .then((res) => {
      saveUser(res.user)
      this.props.updateUser(res.user)
      this.props.updateRequestStatus(res.status, res.message)
      this.context.toggleModal(false)
    })
    .catch((err) => {
      const errors = !!err.fields ? {...err.fields} : {}
      this.setState({ errors })
      this.props.updateRequestStatus(err.status, err.message)
    })

    if(this.state.picture.status) {this._updatePicture()}
  }

  _updatePicture() {
    let formData = new FormData();
    formData.append('picture', this.state.picture.file)
    this.props.updateRequestStatus('progress', 'Cambio de Imagen en progreso...')

    request(UPDATE_PROFILE_PICTURE_URL(retrieveUser().uuid), {
      method: 'PUT',
      isUpload: true,
      body: formData
    })
      .then((res) => {
        saveUser(res.user)
        this.props.updateUser(res.user)
        this.props.updateRequestStatus(res.status, res.message)
      })
      .catch((err) => {
        this.props.updateRequestStatus('error', err.message)
      })
  }

  _validate(e) {
    let formData = {
      ...this.state.formData,
      [e.target.name]: e.target.value
    }
    const validator = new Validator(formData, EditAccount.validationRules)
    this.setState({
      buttonProps: {
        disabled: !validator.passes()
      }
    })
  }

  render() {
    const formData = this.state.formData
    return (
      <div id="EditAccount" className="EditModal Modal__content">
        <div className="EditModal__header d-flex justify-content-between align-items-center">
          <h1>Editar perfil</h1>
          <span className="material-icons close-button" onClick={() => this.context.toggleModal(false)}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex EditModal__form">
          <div className="field-title">
            <h2 className="bold-text">Datos de cuenta</h2>
          </div>
          <div className="modal-elements-container">
            <div className="modal-elements d-flex justify-content-between">
              <Input  id="first_name"
                      name="first_name"
                      errors={this.state.errors.first_name}
                      onChange={this._handleChange}
                      placeholder="Nombre"
                      value={formData.first_name}
                      autoFocus />
              <Input  id="last_name"
                      name="last_name"
                      errors={this.state.errors.last_name}
                      onChange={this._handleChange}
                      placeholder="Apellido"
                      value={formData.last_name} />
            </div>
            <div className="modal-elements message d-flex justify-content-between">
              <p className="message cl-achromatic-b-color">
                Este correo electrónico será usado para iniciar sesión por lo que deberá ser real.
              </p>
            </div>
            <div className="modal-elements d-flex justify-content-between">
              <Input  id="email"
                      name="email"
                      type="email"
                      errors={this.state.errors.email}
                      onChange={this._handleChange}
                      placeholder="Correo"
                      value={formData.email} />
              <Input  id="confirm_email"
                      name="confirm_email"
                      type="email"
                      errors={this.state.errors.confirm_email}
                      onChange={this._handleChange}
                      placeholder="Confirmación de correo"
                      value={formData.confirm_email} />
            </div>
            <InputFile  className="EditAccountPictureInput"
                        labelType="light"
                        label="Foto de Perfil"
                        file={this.state.picture.file}
                        onChange={this._handlePictureChange} />

          </div>
          <div className="controls d-flex justify-content-end">
            <Button className="button"
                    size="big"
                    buttonType="primary"
                    {...this.state.buttonProps}>Actualizar datos de cuenta</Button>
          </div>
        </form>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    updateUser: (user) => dispatch(updateUser(user))
  }
}

export default connect(null, mapDispatchToProps)(EditAccount)

EditAccount.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/Header/DropDown/EditAccount/index.js